<template>
  <b-container class="timeline-container" >
    <div class="head">
      <!-- <Headings :data="heading" /> -->
    </div>
    <div class="timeline-test">
      <VueSlickCarousel v-bind="settings" ref="carousel" @afterChange="onSlideChangeHandle" class="timeline-carousel">
        <div class="swiper-slide start">
          <div class="timestamp border_bottom"></div>
          <div class="status"></div>
        </div>
        <div class="swiper-slide upper" v-for="(timeline, index) in timelinedata" :key="index">
          <div class="timestamp up-time text-left" v-if="timeline.position==='up'">
            <span class="description">{{timeline.description}}</span>
            <span class="date">{{timeline.date}}</span>
          </div>
          <div class="status down-time" v-else>
            <span class="description">{{timeline.description}}</span>
            <span class="date">{{timeline.date}}</span>
          </div>
        </div>
       <!-- <div class="swiper-slide start end">
          <div class="timestamp border_bottom"></div>
          <div class="status"></div>
        </div> -->
      </VueSlickCarousel>
    </div>
    <b-row class="controls">
      <div id="prev-btn">
        <a @click="clickPrev">
          <svg
            class="bi bi-arrow-left-circle prev-next-slide"
            width="1.5em"
            height="1.5em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            />
            <path
              fill-rule="evenodd"
              d="M8.354 11.354a.5.5 0 0 0 0-.708L5.707 8l2.647-2.646a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708 0z"
            />
            <path
              fill-rule="evenodd"
              d="M11.5 8a.5.5 0 0 0-.5-.5H6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5z"
            />
          </svg>
        </a>
      </div>
      <b-col id="progress-btn" md="3" sm="2">
        <b-progress :value="sliderPercent" height="0.25rem" variant="danger"></b-progress>
      </b-col>

      <div id="next-btn">
        <a @click="clickNext">
          <svg
            class="bi bi-arrow-right-circle prev-next-slide"
            width="1.5em"
            height="1.5em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            />
            <path
              fill-rule="evenodd"
              d="M7.646 11.354a.5.5 0 0 1 0-.708L10.293 8 7.646 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0z"
            />
            <path
              fill-rule="evenodd"
              d="M4.5 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5z"
            />
          </svg>
        </a>
      </div>
    </b-row>
  </b-container>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Timelinetest",
  components: { VueSlickCarousel },
  props: ["timelinedata", "heading"],
  data() {
    return {
      value: 50,
      totalSlides: 0,
      currentSlideNo: 0,
      sliderPercent: 0,

      settings: {
        autoplay: false,
        cssEase: "ease",
        arrows: false,
        lazyLoad: "progressive",
        slidesToShow: 6,
        slidesToScroll: 1,
        swipe:false,
        infinite: false,
        responsive: [
          
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  methods: {
    onSlideChangeHandle(index) {
      this.currentSlideNo = index + 1;
      this.totalSlides = this.$props.timelinedata.length/2;
      console.log(this.totalSlides);
      this.sliderPercent = (this.currentSlideNo / this.totalSlides) * 100;
    },
    clickPrev() {
      this.value = this.value - 1;
      this.$refs.carousel.prev();
    },
    clickNext() {
      this.value = this.value + 1;
      this.$refs.carousel.next();
    },
  },
};
</script>
<style scoped>
.swiper-slide {
  width: 200px;
  text-align: center;
  font-size: 18px;
  display: inline-block;
  outline: none;
}
.swiper-slide:focus{
  outline: none!important;
}
div:focus{
  outline:none;
}
.timeline-carousel:focus{
  outline:none;
}
.start {
  margin-top: 11.98rem;
}
.border_bottom {
  border-bottom: 2.5px solid #fcb13f;
}
.end{
   border-right: 2px dashed var(--mainBlueColor);
   height: 12rem;
}
.up-time {
  height: 12rem;
  border-left: 2px dashed var(--mainBlueColor);
  /*border-bottom: 2px solid var(--mainBlueColor);
  border-bottom: 2px solid #fcb13f;*/
}
.down-time {
  margin-top: 11.99rem;
  height: 12rem;
  border-left: 2px dashed var(--mainBlueColor);
  /*border-top: 4px solid var(--mainBlueColor);*/
  border-top:2.5px solid #fcb13f;
}
.timestamp {
  text-align: left;
  width: 389px;
  position: relative;
  padding-left: 1rem;
  padding-right: 1.25rem;
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  font-weight: 100;
}
.status {
  text-align: left;
  width: 389px;
  padding-left: 1rem;
  padding-right: 1.25rem;
  /*display: flex;
  justify-content: center; */
  position: relative;
  transition: all 200ms ease-in;
}

.status span {
  font-weight: 600;
  padding-top: 12px;
  width: 92%;
  position:absolute;
}

.description {
  width: 92%;
  font-size: 0.90rem;
  word-wrap: break-word;
}
.date {
  font-size: 1.5rem;
  display: block;
  padding-top: 2.5rem;
  position: absolute;
  bottom: 0;
}

.timeline-test {
  margin-top: 2rem;
}
.prev-next-slide {
  color: var(--mainBlueColor);
  font-size: 1.5rem;
}
.prev-next-slide:hover {
  background: var(--mainRedColor);
  color: var(--mainWhiteColor);
  border-radius: 50%;
}
.controls {
  margin-left: 3rem;
  margin-right: 3rem;
  padding-top: 2rem;
  text-align: center;
  justify-content: center;
}
.progress {
  margin-top: 1rem;
}

.timeline-container{
  padding-left:0;
  padding-right:0;
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
.timestamp{
    text-align:left;
    width: 285px;
  }
  .status{
    text-align: left;
    width: 285px;
  }
  .timeline-container{
  padding-left:15px;
  padding-right:15px;
}
.status span{
  width:90%;
}
.description{
  width:90%;
}

}


@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
.timestamp{
    text-align: left;
    width: 285px;

  }
  .status{
    text-align: left;
    width: 285px;
  }
  .timeline-container{
  padding-left:15px;
  padding-right:15px;
}

}



@media (min-width: 481px) and (max-width: 767px) {
  .border_bottom {
  border-bottom: 2.5px solid #fcb13f;
}

  .head {
    text-align: center;
  }
 .timestamp{
    text-align: left;
    width: 213px;
    padding-left:0.55rem;

  }
  .status{
    text-align: left;
    width: 213px;
    padding-left:0.55rem;
  }
  .down-time{
        height: 15rem;
            margin-top: 14.99rem;
  }
  .end{
     height: 15rem;
  }
  .up-time {
  height: 15rem;
  }
  .start {
  margin-top: 14.98rem;
}
.timeline-container{
  padding-left:15px;
  padding-right:15px;
}
#progress-btn {
    display: none;
    margin: 0;
    padding: 0;
  }
  #prev-btn,
  #next-btn {
    display: inline-block;
    margin-right: 5px;
  }

}
@media (max-width: 480px) {
  #progress-btn {
    display: none;
    margin: 0;
    padding: 0;
  }
  #prev-btn,
  #next-btn {
    display: inline-block;
    margin-right: 5px;
  }
  .border_bottom {
  border-bottom: 2.5px solid #fcb13f;
}
  .head {
    text-align: center;
  }
  .timestamp{
    text-align: left;
    width: 237px;
    padding-left:0.55rem;

  }
  .status{
    text-align: left;
    width: 237px;
    padding-left:0.55rem;
  }
  .down-time{
        height: 15rem;
        margin-top: 14.99rem;
  }
  .up-time {
  height: 15rem;
  }
  .start {
  margin-top: 14.98rem;
}
.end{
  height: 15rem;
}
.timeline-container{
  padding-left:15px;
  padding-right:15px;
}
.status span {
   width:90%;
}
}
</style>